/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {findEmploymentTokens} from '../api'

export const useMutationFindEmploymentTokens = createReactQueryMutationHook('findEmploymentTokens', findEmploymentTokens)
